export const parentData = [
  {
    key: "1",
    ParentImage: "assets/img/parents/parent-01.jpg",
    ChildImage: "assets/img/students/student-01.jpg",
    id: "P124556",
    name: "Thomas",
    Addedon: "Added on 25 Mar 2024",
    Child: "Janet",
    class: "III, A",
    phone: "+1 65738 58937",
    email: "thomas@example.com",
  },
  {
    key: "2",
    ParentImage: "assets/img/parents/parent-02.jpg",
    ChildImage: "assets/img/students/student-02.jpg",
    id: "P124555",
    name: "Marquita",
    Addedon: "Added on 18 Mar 2024",
    Child: "Joann",
    class: "IV, B",
    phone: "+1 47958 41398",
    email: "marquita@example.com",
  },
  {
    key: "3",
    ParentImage: "assets/img/parents/parent-03.jpg",
    ChildImage: "assets/img/students/student-03.jpg",
    id: "P124554",
    name: "Johnson",
    Addedon: "Added on 14 Mar 2024",
    Child: "Kathleen",
    class: "III, A",
    phone: "+1 78688 17496",
    email: "johnson@example.com",
  },
  {
    key: "4",
    ParentImage: "assets/img/parents/parent-04.jpg",
    ChildImage: "assets/img/students/student-04.jpg",
    id: "P124553",
    name: "Claudia",
    Addedon: "Added on 27 Feb 2024",
    Child: "Gifford",
    class: "I, B",
    phone: "+1 72323 05904",
    email: "claudia@example.com",
  },
  {
    key: "5",
    ParentImage: "assets/img/parents/parent-05.jpg",
    ChildImage: "assets/img/students/student-05.jpg",
    id: "P124552",
    name: "Arthur",
    Addedon: "Added on 11 Feb 2024",
    Child: "Lisa",
    class: "II, B",
    phone: "+1 74820 48201",
    email: "arthur@example.com",
  },
  {
    key: "6",
    ParentImage: "assets/img/parents/parent-06.jpg",
    ChildImage: "assets/img/students/student-06.jpg",
    id: "P124551",
    name: "Colleen",
    Addedon: "Added on 24 Jan 2024",
    Child: "Ralph",
    class: "III, B",
    phone: "+1 46169 47202",
    email: "colleen@example.com",
  },
  {
    key: "7",
    ParentImage: "assets/img/parents/parent-07.jpg",
    ChildImage: "assets/img/students/student-07.jpg",
    id: "P124550",
    name: "Robert",
    Addedon: "Added on 19 Jan 2024",
    Child: "Julie",
    class: "V, A",
    phone: "+1 44990 27830",
    email: "robert@example.com",
  },
  {
    key: "8",
    ParentImage: "assets/img/parents/parent-08.jpg",
    ChildImage: "assets/img/students/student-08.jpg",
    id: "P124549",
    name: "Jessie",
    Addedon: "Added on 08 Jan 2024",
    Child: "Janet",
    class: "III, A",
    phone: "+1 84634 04823",
    email: "jessie@example.com",
  },
  {
    key: "9",
    ParentImage: "assets/img/parents/parent-09.jpg",
    ChildImage: "assets/img/students/student-09.jpg",
    id: "P124548",
    name: "Michael",
    Addedon: "Added on 22 Dec 2023",
    Child: "Susan",
    class: "VIII, B",
    phone: "+1 91038 68460",
    email: "michael@example.com",
  },
  {
    key: "10",
    ParentImage: "assets/img/parents/parent-10.jpg",
    ChildImage: "assets/img/students/student-10.jpg",
    id: "P124547",
    name: "Mary",
    Addedon: "Added on 15 Dec 2024",
    Child: "Richard",
    class: "VII, B",
    phone: "+1 35835 71839",
    email: "mary@example.com",
  },
  {
    key: "11",
    ParentImage: "assets/img/parents/parent-11.jpg",
    ChildImage: "assets/img/students/student-11.jpg",
    id: "P124546",
    name: "Edwin",
    Addedon: "Added on 10 Dec 2023",
    Child: "Veronica",
    class: "IX, A",
    phone: "+1 65738 58940",
    email: "edw@example.com",
  },
];
